import React, { useState } from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import {
  CrossIcon,
  DownloadFileIcon,
  EditListIcon,
} from "../../../../assets/images/svg/svg";
import { downloadDocument } from "../../../../service/commonService";

const File = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey || displayLabelKey;
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [valueObj, setValueObj] = useState();
  const [initialValueObj, setInitialValueObj] = useState();
  const dispatch = useDispatch();

  const attributeLov = useSelector((state) => state.product?.attributeLov);
  const displayYes = fieldEle?.["display-yes"];
  const displayYesValues = (fieldEle?.["display-yes-value"] || "yes").split(",").map(v => v.trim().toLowerCase());
  const parentSelectedValue = displayYes ? formState[displayYes] : "";
  
  let shouldDisplay = displayYesValues.includes(String(parentSelectedValue || "").toLowerCase());

  // Robust check against attributeLov state for doctor_category
  if (displayYes === "doctor_category" && attributeLov) {
    const label = (Array.isArray(attributeLov) 
      ? attributeLov[0]?.attribute_lov_label 
      : attributeLov?.attribute_lov_label) || "";
      
    if (displayYesValues.includes(label.toLowerCase())) {
      shouldDisplay = true;
    }
  }

  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      dispatch(setRendererFormState({ key, value: "" }));
    }
  }, [displayYes, shouldDisplay, key, dispatch]);

  useEffect(() => {
    if (formState && Object.keys(formState).length > 0) {
      if (formState?.files && formState.hasOwnProperty(key)) {
        setInitialValueObj(formState.files[key]);
        setValueObj(formState.files[key]);
      } else if (formState.hasOwnProperty(key)) {
        setInitialValueObj(formState[key]);
        setValueObj(formState[key]);
      }
    }
  }, [key, formState]);

  if (displayYes && !shouldDisplay) {
    return null;
  }

  const handleCancelEdit = () => {
    setIsEditing(false);
    setValueObj(initialValueObj);
  };

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div className="file-wrapper-container">
          <div className="custom-file" id={`${newElfromJSON}_custom-file`}>
            {initialValueObj?.file_name && !isEditing ? (
              <div className="file-info">
                <span className="file-name">{initialValueObj?.file_name}</span>
                <div className="documents-button-wrapper">
                  <Button
                    className="downloadedit--button"
                    onClick={() => {
                      if (valueObj?.media_id) {
                        downloadDocument(
                          valueObj.media_id,
                          valueObj?.file_name || "downloaded-file"
                        );
                      } else {
                        console.error("No media_id available for download.");
                      }
                    }}
                  >
                    <DownloadFileIcon />
                  </Button>
                  <Button
                    className="downloadedit--button"
                    onClick={() => setIsEditing(true)}
                  >
                    <EditListIcon />
                  </Button>
                </div>
              </div>
            ) : (
              <div className="file-input-wrap">
                <input
                  id={newElfromJSON}
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                  type="file"
                  className={`custom-file-input form-control ${
                    error ? "is-invalid" : ""
                  }`}
                  placeholder={fieldEle?.["display-placeholder"]}
                  required={
                    fieldEle?.["display-required"] === 1 && !formState[`${key}`]
                  }
                  disabled={fieldEle?.["display-disabled"] === 1}
                  accept={fieldEle?.["validation-filepattern"]}
                  name={key}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const maxSize = fieldEle?.["validation-filesize"];
                      const maxSizeParts = maxSize ? maxSize?.split(" * ") : [];
                      let maxSizeInBytes = 0;

                      if (maxSize) {
                        const maxSizeParts = maxSize.split(" * ");
                        if (maxSizeParts.length === 3) {
                          maxSizeInBytes =
                            parseInt(maxSizeParts[0], 10) *
                            parseInt(maxSizeParts[1], 10) *
                            parseInt(maxSizeParts[2], 10);
                        }
                      }

                      if (maxSizeInBytes > 0 && file.size > maxSizeInBytes) {
                        setError(
                          `File size exceeds the limit of ${
                            maxSizeParts[2] || "unknown"
                          } MB`
                        );
                        e.target.value = null;
                        dispatch(setRendererFormState({ key, value: null }));
                        return;
                      }

                      setError("");

                      dispatch(setRendererFormState({ key, value: file }));
                      setValueObj({
                        file_name: file.name,
                      });
                    }
                  }}
                />

                <label
                  className={`custom-file-label ${
                    !isEditing ? "without-cross" : ""
                  }`}
                >
                  {valueObj?.file_name || valueObj?.name || "Choose File"}
                </label>
                {isEditing && (
                  <span
                    className="cross--button"
                    onClick={handleCancelEdit}
                    style={{ cursor: "pointer" }}
                  >
                    <CrossIcon />
                  </span>
                )}
                {error && <div className="invalid-feedback">{error}</div>}
              </div>
            )}
            {(!valueObj || isEditing) && (
              <div className="file-type-container">
                {fieldEle?.["display-description"] ||
                fieldEle?.["validation-filepattern"] ||
                fieldEle?.["validation-filesize"] ? (
                  <>
                    {fieldEle?.["display-description"] ? (
                      <span>{fieldEle["display-description"]}</span>
                    ) : (
                      <>
                        {fieldEle?.["validation-filepattern"] && (
                          <span>
                            File Type:{" "}
                            {fieldEle["validation-filepattern"]
                              .replace(".", "")
                              .toUpperCase()}
                          </span>
                        )}
                        {fieldEle?.["validation-filesize"] && (
                          <span
                            className="file-size"
                            style={{ marginLeft: "auto" }}
                          >
                            Max File Size:{" "}
                            {fieldEle["validation-filesize"]
                              .split(" * ")
                              .reduce((acc, val) => acc * parseInt(val), 1) /
                              (1024 * 1024)}{" "}
                            MB
                          </span>
                        )}
                      </>
                    )}
                  </>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </FormGroupWrapper>
  );
};

export default File;
